import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Loader2, Gift, ShieldCheck } from 'lucide-react';

export const ReferralLanding = () => {
    const { id } = useParams<{ id: string }>(); // This grabs the USER_ID from the URL
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            // 1. Store the referrer's ID securely in local storage
            localStorage.setItem('scoop_referrer_uid', id);
            
            // 2. Short delay for a cool "Securing Connection" vibe before sending them to home/auth
            const timer = setTimeout(() => {
                navigate('/');
            }, 2500);
            return () => clearTimeout(timer);
        }
    }, [id, navigate]);

    return (
        <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-500">
            <div className="w-24 h-24 border-2 border-white rounded-full flex items-center justify-center mb-8 animate-pulse shadow-[0_0_30px_rgba(255,255,255,0.2)]">
                <Gift size={40} className="text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-white uppercase italic tracking-tighter mb-4">
                Invitation Accepted
            </h1>
            <p className="text-zinc-500 font-mono text-xs uppercase tracking-[0.3em] mb-12">
                Validating Network Protocol
            </p>
            <div className="flex items-center gap-4 text-white bg-zinc-950 border border-zinc-800 px-6 py-4 rounded-full">
                <Loader2 className="animate-spin" size={18} />
                <span className="text-[10px] font-black uppercase tracking-widest">Securing Connection...</span>
            </div>
            <div className="mt-auto pb-10 flex items-center gap-2 text-zinc-700 text-[10px] font-mono uppercase tracking-widest">
                <ShieldCheck size={14} /> hyp.scoop.co.za security_layer_active
            </div>
        </div>
    );
};